import { CLASSES_TYPES } from "./classesTypes";
import { convertToObjById } from "helpers/convertToObject";

const {
    GET_CLASSES,
} = CLASSES_TYPES

const initialState = {
    classes: [],
}

export const classesReducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case GET_CLASSES:
            return {
                ...state,
                classes: convertToObjById(payload)
            }
        default: return state
    }
}